import {useState} from "react";
import {CPE_STATUS_TYPES, CpeStatusTypes, ONT_STATUS_TYPES, OntStatusTypes, ProductInstance} from "../../../util/types.ts";
import Cpe from "./Cpe.tsx";
import Ont from "./Ont.tsx"
import Icon from "../Icon.tsx";
import {Link} from "react-router-dom";
import IconGlobe from "../../icons/IconGlobe.tsx";

export default function InternetStatus({customer_id, product_instance}: { customer_id: string; product_instance: ProductInstance; }) {
    const [mac, setMac] = useState<string | undefined>(product_instance.can_see_ont_internet_status ? undefined : '');
    const [cpeStatus, setCpeStatus] = useState<CpeStatusTypes>();
    const [ontStatus, setOntStatus] = useState<OntStatusTypes>();

    return (
        <div className={'selfcare-internet-status'}>
            <div className={'title'}>
                <h2 className={'heading heading--montserrat'}>Status på dit internet</h2>
                <p>
                    Her kan du se, om vi har forbindelse til {product_instance.can_see_ont_internet_status && 'din fiberboks og'} din router.
                </p>
            </div>
            <div className={'status'}>
                <Cpe customer_id={customer_id} product_instance={product_instance} setCpeStatus={setCpeStatus} mac={mac}/>
                {product_instance.can_see_ont_internet_status &&
                    <Ont customer_id={customer_id} product_instance={product_instance} setOntStatus={setOntStatus} setMac={setMac}/>
                }
                <div className={'device-container device-container--internet'}>
                    <div className={'device'}>
                        <Icon component={IconGlobe}/>
                        <p>Internet</p>
                    </div>
                </div>
            </div>
            {product_instance.can_see_ont_internet_status ? (
                <>
                    {ontStatus === ONT_STATUS_TYPES.down && (
                        <p className={'status-message'}>
                            Det ser ud til, at din fiberboks ikke er tændt.
                            Tænd den på on/off-knappen.
                            Hvis det ikke hjælper, kan du følge{' '}
                            <Link to={'/hjaelp/internet-og-wifi/offline#fiber'} target={'_blank'}>denne vejledning</Link>{' '}
                            for at fejlsøge.
                            Hvis det stadig ikke virker, kan du fejlmelde dit internet herunder.
                        </p>
                    )}
                    {ontStatus === ONT_STATUS_TYPES.fail && (
                        <p className={'status-message'}>
                            Vi kan ikke hente data for din fiberboks lige nu. Prøv igen senere.
                        </p>
                    )}
                    {ontStatus === ONT_STATUS_TYPES.up && cpeStatus === CPE_STATUS_TYPES.noMac && (
                        <p className={'status-message'}>
                            Din router er offline.
                            Sørg for at din router er tændt og at kablerne sidder korrekt.
                            Tjek evt. vores{' '}
                            <Link to={`/hjaelp/udstyr/installationsmanual`}>
                                installations&shy;vejledninger
                            </Link>{' '}
                            for at se hvordan din router skal sættes op.
                        </p>
                    )}
                    {ontStatus === ONT_STATUS_TYPES.up && cpeStatus === CPE_STATUS_TYPES.down && (
                        <p className={'status-message'}>
                            Vi kan ikke komme i kontakt med din router.
                            Det ser ud til, at du bruger din egen router.
                            Hvis du oplever problemer med dit internet, kan du prøve at sætte din Hiper-router til.
                        </p>
                    )}
                    {ontStatus === ONT_STATUS_TYPES.up && cpeStatus === CPE_STATUS_TYPES.up && (
                        <p className={'status-message'}>
                            Dit internet kører! Vi har forbindelse til både din fiberboks og router.
                            Hvis du har brug for hjælp til at logge på dit wifi, kan du læse vores{' '}
                            <Link to={'/hjaelp/internet-og-wifi/navn-og-kode-til-wifi'} target={'_blank'}>artikel om wifi-navn og -kode</Link>.
                        </p>
                    )}
                </>
            ) : (
                <>
                    {cpeStatus === CPE_STATUS_TYPES.down && (
                        <p className={'status-message'}>
                            Vi kan ikke komme i kontakt med din router.
                            Det ser ud til, at du bruger din egen router.
                            Hvis du oplever problemer med dit internet, kan du prøve at sætte din Hiper-router til.
                        </p>
                    )}
                    {cpeStatus === CPE_STATUS_TYPES.up && (
                        <p className={'status-message'}>
                            Dit internet kører! Vi har forbindelse til din router.
                            Hvis du har brug for hjælp til at logge på dit wifi, kan du læse vores{' '}
                            <Link to={'/hjaelp/internet-og-wifi/navn-og-kode-til-wifi'} target={'_blank'}>artikel om wifi-navn og -kode</Link>.
                        </p>
                    )}
                </>
            )}
        </div>
    )
}
